import axios from 'axios';

const _axios = axios.create();

export default _axios;